module.exports = __webpack_public_path__ + "img/8.60a8912c.jpg";